const BASE_HEIGHT = 0.22;
const HEIGHT_RANGE = 0.78;

/**
 * Stable decorative bar heights for a segment's waveform. The segment API carries no
 * amplitude data, so heights are derived from the segment id — the same segment always
 * renders the same shape. Played/unplayed colouring (driven by real progress) lives in
 * the Waveform component; this only produces the silhouette.
 */
export function waveformBars(seed: number, count: number): number[] {
  // Math.imul keeps each multiply in 32-bit, so large ids stay a proper LCG (no float
  // precision loss that could collide two distinct ids onto the same silhouette).
  let state = Math.imul(seed, 2654435761) >>> 0 || 1;
  const bars: number[] = [];
  for (let index = 0; index < count; index++) {
    state = (Math.imul(state, 1103515245) + 12345) >>> 0;
    const noise = state / 0xffffffff;
    bars.push(BASE_HEIGHT + HEIGHT_RANGE * (0.5 * noise + 0.5 * Math.abs(Math.sin(index * 0.5))));
  }
  return bars;
}
